/**
 * Contract table column definitions
 */
import { isTheme } from '../Utils/isTheme'
import { isAdmin } from '../Utils/index'

/**
 * Get static columns for wallet client page
 * @param {Function} t - Translation function
 * @returns {Array} Column definitions
 */
export const getWalletClientColumns = (t) => [
  { data: 'id', displayable: false },
  { name: 'client.id', displayable: false },
  { name: 'supplier.id', displayable: false },
  { name: 'refinancerNumber', displayable: false },
  {
    name: 'createdAt',
    title: t('contract.list.table.labelCreatedAt'),
    type: 'date',
    formatter: 'date',
    style: { className: 'col-align-center' },
  },
  {
    name: 'number',
    title: t('contract.list.table.labelNumber'),
    formatter: 'context',
    options: { renderType: 'portefeuille', renderId: 'id' },
  },
  {
    name: 'client.name',
    title: t('main.client'),
  },
  {
    name: 'supplier.name',
    title: t('main.supplier'),
  },
  {
    name: 'finance.equipment.name',
    title: t('contract.list.table.equipment'),
  },
  {
    name: 'finance.amount',
    title: t('contract.list.table.labelTotalAmount'),
    type: 'num-fmt',
    formatter: 'currency',
  },
  {
    name: 'remainingMonth',
    title: t('contract.list.table.remainingMonth'),
  },
  {
    name: 'status',
    title: t('contract.list.table.labelStatus'),
    formatter: 'status',
    options: { renderType: 'contract' },
  },
  {
    name: 'contractMode',
    title: t('contract.list.table.contractMode'),
    style: { width: '120px;' },
    displayable: isTheme('lbp'),
  },
]

/**
 * @param {Function} t - Translation function
 * @returns {Array} Column definitions
 */
export const getContractListColumns = (t) => [
  { data: 'id', displayable: false },
  { name: 'clientId', displayable: false },
  { name: 'supplierId', displayable: false },
  { name: 'simulationId', displayable: false },
  { name: 'refinancerNumber', displayable: false },
  { name: 'accountCodeSupplier', displayable: false },
  {
    name: 'createdAt',
    title: t('contract.list.table.labelCreatedAt'),
    type: 'date',
    formatter: 'date',
    style: { className: 'col-align-center' },
  },
  {
    name: 'number',
    title: t('contract.list.table.labelNumber'),
    formatter: 'context',
    options: { renderType: 'contracts', renderId: 'id' },
  },
  {
    name: 'accountCodeClient',
    title: t('contract.list.table.accountCodeClient'),
    displayable: isTheme('ciscar'),
  },
  {
    name: 'agreementNumber',
    title: t('demand.list.number'),
    style: { className: 'col-align-center' },
    displayable: isTheme('lbp'),
  },
  {
    name: 'clientInfo',
    title: t('main.client'),
    formatter: 'entity',
    options: { renderId: 'clientId' },
  },
  {
    name: 'clientSiren',
    title: t('contract.list.table.sirenClient'),
    formatter: 'entity',
    options: { render: '', renderId: 'clientId' },
    displayable: isTheme('hexapage'),
  },
  {
    name: 'supplierInfo',
    title: t('main.supplier'),
    formatter: 'entity',
    options: { renderId: 'supplierId' },
    displayable: isAdmin(),
  },
  {
    name: 'platformSalesman',
    title: t('contract.list.table.labelPlatformSalesman'),
  },
  {
    name: 'platformName',
    title: t('contract.list.table.platformName'),
    format: 'entity',
    options: { renderId: 'platformId' },
    displayable: !isTheme('financia'),
  },
  {
    name: 'companySalesmanName',
    title: t('contract.list.table.companySalesmanName'),
    displayable: !isTheme('financia'),
  },
  { name: 'equipmentType', title: t('contract.list.table.equipment') },
  {
    name: 'rentMonthly',
    title: t('contract.list.table.labelRentMonthly'),
    type: 'numeric',
    formatter: 'currency',
    style: { width: '60px;' },
    displayable: !isTheme('ciscar'),
  },
  {
    name: 'amount',
    title: t('contract.list.table.labelTotalAmount'),
    type: 'num-fmt',
    formatter: 'currency',
    style: { width: '60px;' },
    displayable: !isTheme('ciscar'),
  },
  {
    name: 'rentAmount',
    title: t('contract.list.table.labelRentAmount'),
    type: 'numeric',
    formatter: 'currency',
    style: { width: '60px;' },
    displayable: isTheme('ciscar'),
  },
  {
    name: 'status',
    title: t('contract.list.table.labelStatus'),
    formatter: 'status',
    style: { width: '120px;' },
    options: { renderType: 'contract' },
  },
  {
    name: 'esign',
    title: t('contract.list.table.esign'),
    formatter: 'boolean',
    style: { width: '40px;' },
    displayable: isTheme('ciscar', 'olinn', 'financia'),
  },
  {
    name: 'formerContractNumber',
    title: t('contract.list.table.formerContractNumber'),
    displayable: isTheme('ciscar', 'olinn'),
  },
  {
    name: 'deliveryLabel',
    title: t('contract.list.table.labelDeliveryAddress'),
    style: { width: '120px;' },
    displayable: isTheme('ciscar'),
  },
  {
    name: 'refinancerName',
    title: t('contract.list.table.refinancerName'),
    style: { width: '120px;' },
    displayable: isTheme('ciscar') && (window.user?.isBusinessMan || window.user?.isAdmin),
  },
  {
    name: 'contractMode',
    title: t('contract.list.table.contractMode'),
    style: { width: '120px;' },
    displayable: isTheme('lbp'),
  },
  { name: 'platformId', displayable: false },
  {
    name: 'reportingVariables',
    title: t('contract.list.table.reportingVariables'),
    style: { width: '120px;' },
    displayable: isTheme('hexapage'),
  },
]
